"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const postmate_1 = __importDefault(require("postmate"));
const api_1 = require("./api");
const useEventsActions_1 = require("./useEventsActions");
const usePlayerSetup_1 = require("./usePlayerSetup");
const utils_1 = require("./utils");
const UPDATE_VERSION_TIMEOUT = 60000;
function usePlayer({ debug }) {
    const childApiRef = (0, react_1.useRef)(null);
    const [currentPlayerUrl, setCurrentPlayerUrl] = (0, react_1.useState)(null);
    const [currentTrack, setCurrentTrack] = (0, react_1.useState)(null);
    const [setupOptions, setSetupOptions] = (0, react_1.useState)(null);
    const silentAudio = (0, react_1.useRef)();
    const onFrameDestroy = (0, react_1.useCallback)(() => {
        var _a;
        try {
            (_a = childApiRef === null || childApiRef === void 0 ? void 0 : childApiRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
        }
        catch (error) {
            console.error(error);
        }
        try {
            if (setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.container) {
                setupOptions.container.innerHTML = "";
            }
        }
        catch (error) {
            console.error(error);
        }
    }, [childApiRef === null || childApiRef === void 0 ? void 0 : childApiRef.current, setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.container]);
    (0, react_1.useEffect)(() => {
        postmate_1.default.debug = debug !== null && debug !== void 0 ? debug : false;
        return () => {
            onFrameDestroy();
        };
    }, []);
    const actions = (0, useEventsActions_1.useEventsActions)(childApiRef, currentTrack);
    const checkUpdates = (0, react_1.useCallback)((newUrl) => {
        if (!setupOptions || !newUrl || currentPlayerUrl === null)
            return;
        if (newUrl !== currentPlayerUrl && !setupOptions.rewritePlayerUrl) {
            setup(setupOptions.container, setupOptions.bindingCode, setupOptions.apiUrl, setupOptions.styles, setupOptions.frameStyle, setupOptions.settings, setupOptions.rewritePlayerUrl);
        }
    }, [
        setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.container,
        setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.bindingCode,
        setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.apiUrl,
        setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.styles,
        setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.frameStyle,
        setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.settings,
        setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.rewritePlayerUrl,
        currentPlayerUrl,
    ]);
    const updateFrameUrl = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        if (!(setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.bindingCode) || !setupOptions.apiUrl)
            return;
        const playerUrl = yield (0, api_1.getWebPlayerUrl)(setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.bindingCode, setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.apiUrl);
        checkUpdates(playerUrl);
    }), [setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.bindingCode, setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.apiUrl, checkUpdates]);
    (0, react_1.useEffect)(() => {
        const timer = setInterval(updateFrameUrl, UPDATE_VERSION_TIMEOUT);
        updateFrameUrl();
        return () => clearInterval(timer);
    }, [updateFrameUrl]);
    const { state, setup, frameStatus } = (0, usePlayerSetup_1.usePlayerSetup)({
        onFrameDestroy,
        setSetupOptions,
        childApiRef,
        setCurrentPlayerUrl,
        currentTrack,
        setCurrentTrack,
    });
    (0, react_1.useEffect)(() => {
        try {
            if ((setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.bindingCode) && (childApiRef === null || childApiRef === void 0 ? void 0 : childApiRef.current)) {
                const updateChannel = (0, utils_1.getAppUpdateChannel)(setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.bindingCode);
                const appVersion = (0, utils_1.getAppVersion)(setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.bindingCode);
                if (appVersion) {
                    actions.setSetting("APP_VERSION", appVersion);
                }
                if (updateChannel) {
                    actions.setSetting("APP_UPDATE_CHANNEL", updateChannel);
                }
            }
        }
        catch (err) {
            console.error(err);
        }
    }, [actions.setSetting, setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.bindingCode, childApiRef === null || childApiRef === void 0 ? void 0 : childApiRef.current, currentPlayerUrl]);
    (0, react_1.useEffect)(() => {
        const src = setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.silenceDataUri;
        if (!src || silentAudio.current || frameStatus !== "enabled") {
            return;
        }
        silentAudio.current = new Audio();
        silentAudio.current.src = src;
        silentAudio.current.preload = "auto";
        silentAudio.current.loop = true;
        silentAudio.current.autoplay = true;
    }, [setupOptions === null || setupOptions === void 0 ? void 0 : setupOptions.silenceDataUri, silentAudio, frameStatus]);
    return {
        frameStatus,
        setup,
        state,
        actions,
    };
}
exports.default = usePlayer;
//# sourceMappingURL=usePlayer.js.map